<template>
  <q-btn-group v-if="multiple">
    <q-btn
      v-for="button in options"
      :key="button.value"
      :ripple="false"
      :label="button.label"
      :color="btnBgColor(button.value)"
      :text-color="btnColor(button.value)"
      :padding="$attrs.padding"
      @click="toggle(button.value)"
    />
  </q-btn-group>
  <q-btn-toggle
    v-else
    :ripple="false"
    :options="options"
    :value="value"
    no-caps
    unelevated
    v-bind="$attrs"
    @input="$emit('input', $event)"
  >
    <slot/>
  </q-btn-toggle>
</template>

<script>
export default {
  name: 'AppButtonToggle',
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: undefined,
    },
    value: {
      type: [Array, String],
      default: undefined,
    },
  },
  methods: {
    toggle(buttonValue) {
      const values = [...this.value];
      const index = values.indexOf(buttonValue);
      if (index === -1) {
        values.push(buttonValue);
      } else {
        values.splice(index, 1);
      }
      this.$emit('input', values);
    },
    btnColor(buttonValue) {
      return this.value.includes(buttonValue) ? this.$attrs['toggle-text-color'] : 'black';
    },
    btnBgColor(buttonValue) {
      return this.value.includes(buttonValue) ? this.$attrs['toggle-color'] : 'white';
    },
  },
};
</script>

<style lang="scss" scoped>
.q-btn-group {
  background: #fff;

  ::v-deep button {
    border: 1px solid $grey-2;
  }

  &--outline {
    ::v-deep .q-btn__content span {
      font-weight: 500;
    }
  }
}
</style>
